












import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "ProfileHeaderBackground",
  props: {
    background: { type: String, required: true },
  },
});
